import { Link } from "@/navigation";

interface DetailPageBannerProps {
	title: string;
	materialName: string;
	description: string;
	buttonText: string;
	buttonHref: string;
}

const DetailPageBanner = ({
	title,
	materialName,
	description,
	buttonText,
	buttonHref,
}: DetailPageBannerProps) => {
	return (
		<div className="container py-20">
			<div className="flex flex-col items-center justify-center">
				<p className="mb-2 text-base font-bold text-[#707070]">{title}</p>
				<h1 className="mb-4 text-4xl font-bold max-md:text-2xl">{materialName}</h1>
				<p className="mb-10 max-w-[600px] text-center text-base text-[#707070]">{description}</p>
				<Link href={buttonHref}>
					<button className="rounded-sm bg-[#65a525] px-6 py-2 font-bold text-white">{buttonText}</button>
				</Link>
			</div>
		</div>
	);
};

export default DetailPageBanner;
